// extracted by mini-css-extract-plugin
module.exports = {"companies":"companies-module--companies--2fZt1","company":"companies-module--company--1YUbB"};